<div>
    <img [width]="width ? width : 190" [height]="height ? height : 153" src="assets/imgs/empty.svg" alt="empty image">
    <h1>{{'status.empty_data' | translate}}</h1>
    <p class="empty__text">{{'status.empty_data' | translate}}</p>
</div>
